import React from "react";
import XAvatar from "../../../base-ui/XAvatar";
import { AvatarGroup, Box } from "@mui/material";

export const AvatarGroupCell = ({
  value,
  valueFn,
}: {
  value: string | string[] | null;
  valueFn: (value: string) => string;
}) => {
  if (!value) return <></>;
  else if (typeof value === "string") {
    if (value === "None" || value === "[None]") return <></>;
    else {
      try {
        const avatars = JSON.parse(value.replace(/'/g, `"`));
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <AvatarGroup
              max={6}
              sx={{
                "& .MuiAvatar-root": {
                  width: "32px",
                  height: "32px",
                  zIndex: 1,
                },
              }}
            >
              {avatars.map((userCC: string) => (
                <XAvatar key={userCC} width={28} height={28} value={valueFn(userCC)} />
              ))}
            </AvatarGroup>
          </Box>
        );
      } catch (e) {
        return <></>;
      }
    }
  } else {
    return <>N/A</>;
  }
};
